// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1iDYf","notes":"Notes_notes__2l8QC"};